var map = {
	"./AXA.png": 7110,
	"./Allianz.png": 3829,
	"./Aviva.png": 4963,
	"./Bupa.png": 5362,
	"./Cigna.jpeg": 9191,
	"./Freedom.png": 9624,
	"./Image.png": 2469,
	"./TheExeter.png": 6438,
	"./Vitality.png": 9134,
	"./WPA.png": 6456,
	"./attract.svg": 7601,
	"./build.svg": 6690,
	"./calender.svg": 5212,
	"./footer-logo.png": 421,
	"./grow.svg": 5211,
	"./logo-small.svg": 3878,
	"./logo.png": 3845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4366;